import * as types from '../../mutation-types'
import { addOrUpdateItem, removeItem } from '../../helpers'

export default {
    [types.OPEN_MESSAGE_MODAL]: (state, {context, entity_type, entity, isReminder, closable, locService}) => {
        state.messageModal.entity_type = entity_type
        state.messageModal.entity = entity
        state.messageModal.context = context
        state.messageModal.active = true
        state.messageModal.isReminder = isReminder
        state.messageModal.closable = closable
        state.messageModal.locService = locService
    },

    [types.CLOSE_MESSAGE_MODAL]: (state, item) => {
        state.messageModal.active = false
    },

    [types.SET_FORCE_ROUTE_KEY]: (state, value) => {
        state.isRouteKeyForced = value
    }
}
